module.exports = __webpack_public_path__ + "static/media/hsbc_logo_tc.b1b6cb1c.svg";